var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritesLinksBlueActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 16,
    height: 16,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2363F7",
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99998557,0 C8.42848876,0 8.8169085,0.210063931 9.0439113,0.55645365 L9.11347216,0.676864843 L10.8010925,4.02102722 C10.8709592,4.15954458 11.006007,4.25547848 11.1622738,4.27768298 L14.9359529,4.81394413 C15.4071152,4.88089295 15.7911536,5.19756794 15.9383156,5.64039134 C16.0854014,6.08321474 15.9650585,6.56016452 15.6241439,6.88518483 L12.8934751,9.48829048 C12.7803703,9.596109 12.7287893,9.75135425 12.7554941,9.90354452 L13.4001422,13.5791352 C13.4805994,14.0380532 13.2913421,14.493171 12.9061227,14.7668527 C12.5209415,15.0404971 12.0198744,15.0758157 11.5985408,14.85921 L8.22326194,13.1238311 C8.0834523,13.0519272 7.91659503,13.0519645 7.7767473,13.1238311 L4.40150656,14.85921 C4.21823023,14.9534301 4.01986817,15 3.82253468,15 C3.56619162,15 3.31156285,14.9214646 3.09392458,14.7667782 C2.70874333,14.4930965 2.51944794,14.0380159 2.59994325,13.579098 L3.24455327,9.90350727 C3.27125806,9.75127974 3.21967706,9.59603448 3.10657221,9.48825322 L0.375903408,6.88518483 C0.0349888553,6.56016452 -0.0854302866,6.08321474 0.0616936381,5.64039134 C0.208817563,5.19756794 0.592894054,4.88089295 1.06405633,4.81394413 L4.83773547,4.27768298 C4.99404036,4.25547848 5.12904999,4.15954458 5.19895481,4.02102722 L6.88657517,0.676864843 C7.0972801,0.259338187 7.52390901,0 7.99998557,0 Z",
    transform: "translate(0 .5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesLinksBlueActive);
export default __webpack_public_path__ + "static/media/favoritesLinks_blue_active.6fff72f8caf302dc636c63b291de246b.svg";
export { ForwardRef as ReactComponent };